export default {"src":"/_next/static/media/data-deletion-and-retention.dc0193cd.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};